import React from 'react';
import { css } from '@emotion/css';

function Hours() {
  return (
    <div className={style.container} id="oeffnungszeiten">
      <div className={style.title}>&Ouml;ffnungszeiten</div>
      <div className={style.hoursContainer}>
        <div className={style.day}>
          <div className={style.line}>Montag</div>
          <div className={style.line}>Dienstag</div>
          <div className={style.line}>Mittwoch</div>
          <div className={style.line}>Donnerstag</div>
          <div className={style.line}>Freitag</div>
          <div className={style.line}>Samstag</div>
          <div className={style.line}>Sonntag</div>
        </div>
        <div className={style.hoursForenoon}>
          <div className={style.line}>geschlossen</div>
          <div className={style.line}>07:00 - 16:00</div>
          <div className={style.line}>06:00 - 16:00</div>
          <div className={style.line}>08:00 - 12:00</div>
          <div className={style.line}>06:00 - 16:00</div>
          <div className={style.line}>06:00 - 13:00</div>
          <div className={style.line}>geschlossen</div>
        </div>
        <div className={style.hoursAfternoon}>
          <div className={style.line}>&nbsp;</div>
          <div className={style.line}>&nbsp;</div>
          <div className={style.line}>&nbsp;</div>
          <div className={style.line}>14:00 - 18:00</div>
          <div className={style.line}>&nbsp;</div>
          <div className={style.line}>&nbsp;</div>
          <div className={style.line}>&nbsp;</div>
        </div>
      </div>
    </div>
  );
}

const style = {
  container: css`
    padding: 10px;
  `,
  title: css`
    font-size: 24px;
  `,
  hoursContainer: css`
    display: flex;
    justify-content: space-between;
    max-width: 50%;
    @media (max-width: 380px) {
      font-size: 14px;
    }
    @media (max-width: 800px) {
      max-width: 75%;
    }
    @media (max-width: 640px) {
      max-width: 100%;
    }
  `,
  day: css`
    flex: 1;
  `,
  hoursForenoon: css`
    width: 30%;
    text-align: left;
    @media (max-width: 400px) {
      width: 33%;
    }
  `,
  hoursAfternoon: css`
    width: 30%;
    text-align: right;
    @media (max-width: 400px) {
      width: 33%;
    }
  `,
  line: css`
    padding: 2px 5px;
    &:nth-child(2n) {
      background-color: #f3f3f3;
    }
  `,
};

export default Hours;
